import { LayoutServiceData } from '@sitecore-jss/sitecore-jss-nextjs';
import { AFFILIATE_PREFIX, getAffiliateIdFromRewrite } from 'lib/affiliate/utils';
import { SitecoreIds } from 'lib/constants/sitecore-ids';
import { Condition } from 'lib/rules/types';
import { GetStaticPropsContext } from 'next';
import { Plugin } from '..';

class UserAffiliatePlugin implements Plugin {
  conditionId = SitecoreIds.Settings.Rules.Definitions.Elements.RbA_Reviews.UserAffiliate.ItemId;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async exec(condition: Condition, context: GetStaticPropsContext, _layout: LayoutServiceData) {
    const affiliatePath = (context?.params?.path as string[])?.find((x) =>
      x.includes(AFFILIATE_PREFIX)
    );
    //@ts-ignore allow for extra condition properties
    condition.userAffiliateId = getAffiliateIdFromRewrite(affiliatePath || '');

    return condition;
  }
}

export const userAffiliatePlugin = new UserAffiliatePlugin();
